import React from "react";
import { connect } from "react-redux";

import Tooltip from "@/src/components/common/Elements/Tooltip/Tooltip";
@connect( store => {
    return { 
        loggedUser: store.loggedUser,
        conversations: store.conversations
    };
})

class Archive extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {note, action, conversations, isAdmin, isAdminWithoutWslead, loggedUser}=this.props
        const handleArchived =()=>{
            if(note.isArchived) {
                action() 
            } else {
                $('#archivedConfirmation').modal('show')
            }
        }

        if( conversations.selected.id ) {
             const isMember = conversations.selected.tagged_users.filter(t=>t.linkId === loggedUser.data.id);
             const isCreator = conversations.selected.createdBy  === loggedUser.data.id
            return (
                <div>
                    {(isAdminWithoutWslead || isCreator || (loggedUser.data.userType ==='Internal' && isMember.length > 0)) ?
                        <a class="active"   data-tooltip-id={`conversation-archive`} onClick={handleArchived}>
                            <i class="material-icons">{note.isArchived ? 'unarchive' : 'archive'}</i>
                        </a> :
                        <a class="disabled"   data-tooltip-id={`conversation-archive`}>
                            <i class="material-icons">{note.isArchived ? 'unarchive' : 'archive'}</i>
                        </a>
                    }
                    
                    <Tooltip id={`conversation-archive`} place="bottom" effect="solid">{note.isArchived?'Unarchive':'Archive'}</Tooltip>
                </div>
            );
        }
    }
}

export default Archive;